import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ko',
  months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
  weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
  weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'A h:mm',
    lts: 'A h:mm:ss',
    L: 'YYYY. M. D.',
    LL: 'YYYY년 MMMM D일',
    'LL-D': 'YYYY년 MMMM',
    'LL-Y': 'MMMM D일',
    LLL: 'YYYY년 MMMM D일 HH:mm',
    'LLL-Y': 'MMMM D일 HH:mm',
    LLLL: 'YYYY년 MMMM D일 dddd HH:mm',
    'LLLL-Y': 'dddd MMMM D일 HH:mm',
    l: 'YYYY. M. D.',
    'l-Y': 'M. D.',
    ll: 'YYYY년 MMM D일',
    'll-Y': 'MMM D일',
    'll-D': 'YYYY년 MMM',
    lll: 'YYYY년 MMM D일 A h:mm',
    'lll-Y': 'MMM D일 A h:mm',
    llll: 'YYYY년 MMM D일 (ddd) A h:mm',
    'llll-Y': 'MMM D일 (ddd) A h:mm',
    'll-Y+w': 'MMM D일 (ddd)',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'YYYY년 MMMM D일 HH:mm ([GMT]Z)',
  },
  meridiem: { am: '오전', pm: '오후', AM: '오전', PM: '오후' },
  past: {
    y: { other: '%s년 전' },
    M: { other: '%s개월 전' },
    w: { other: '%s주 전' },
    d: { other: '%s일 전' },
    h: { other: '%s시간 전' },
    m: { other: '%s분 전' },
    s: { other: '%s초 전' },
  },
  future: {
    y: { other: '%s년 후' },
    M: { other: '%s개월 후' },
    w: { other: '%s주 후' },
    d: { other: '%s일 후' },
    h: { other: '%s시간 후' },
    m: { other: '%s분 후' },
    s: { other: '%s초 후' },
  },
  pastLong: {
    y: { other: '%s년 전' },
    M: { other: '%s개월 전' },
    w: { other: '%s주 전' },
    d: { other: '%s일 전' },
    h: { other: '%s시간 전' },
    m: { other: '%s분 전' },
    s: { other: '%s초 전' },
  },
  futureLong: {
    y: { other: '%s년 후' },
    M: { other: '%s개월 후' },
    w: { other: '%s주 후' },
    d: { other: '%s일 후' },
    h: { other: '%s시간 후' },
    m: { other: '%s분 후' },
    s: { other: '%s초 후' },
  },
  abbr: {
    y: { other: '%s년' },
    M: { other: '%s개월' },
    w: { other: '%s주' },
    d: { other: '%s일' },
    h: { other: '%s시간' },
    m: { other: '%s분' },
    s: { other: '%s초' },
  },
  full: {
    y: { other: '%s년' },
    M: { other: '%s개월' },
    w: { other: '%s주' },
    d: { other: '%s일' },
    h: { other: '%s시간' },
    m: { other: '%s분' },
    s: { other: '%s초' },
  },
  justNow: '방금',
  yesterday: '어제',
  today: '오늘',
  tomorrow: '내일',
  weekStart: 0,
  timeRange: '%$1s ~ %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'A h:mm' },
  timeRangeStyles: {
    yl: { start: 'YYYY년 MMMM D일', end: 'YYYY년 MMMM D일' },
    'yl-1': { start: 'YYYY년 MMMM D일', end: 'MMMM D일' },
    ml: { start: 'MMMM D일', end: 'MMMM D일' },
    'ml-1': { start: 'YYYY년 M월 D일', end: 'D일' },
    dl: { start: 'MMMM D일', end: 'D일' },
    y: { start: 'YYYY년 M월 D일', end: 'YYYY년 M월 D일' },
    'y-1': { start: 'YYYY년 M월 D일', end: 'M월 D일' },
    m: { start: 'M월 D일', end: 'M월 D일' },
    'm-1': { start: 'YYYY년 M월 D일', end: 'D일' },
    d: { start: 'MMM D일', end: 'D일' },
    Y: { start: 'YYYY년 M월 D일 (ddd)', end: 'YYYY년 M월 D일 (ddd)' },
    'Y-1': { start: 'YYYY년 M월 D일 (ddd)', end: 'M월 D일 (ddd)' },
    M: { start: 'M월 D일 (ddd)', end: 'M월 D일 (ddd)' },
    D: { start: 'M월 D일 (ddd)', end: 'M월 D일 (ddd)' },
    yt: { start: 'YYYY년 M월 D일 HH:mm', end: 'YYYY년 M월 D일 HH:mm' },
    mt: { start: 'M월 D일 HH:mm', end: 'M월 D일 HH:mm' },
    dt: { start: 'M월 D일 HH:mm', end: 'M월 D일 HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY년 M월 D일 HH:mm', end: 'YYYY년 M월 D일 HH:mm ([GMT]Z)' },
    'mt+to': { start: 'M월 D일 HH:mm', end: 'M월 D일 HH:mm ([GMT]Z)' },
    'dt+to': { start: 'M월 D일 HH:mm', end: 'M월 D일 HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ko';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}일`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? '오전' : '오전';
    } else {
      return isLowerCase ? '오후' : '오후';
    }
  },
};
